<template>
    <div>

        <div v-if="!em_edicao">

            <div class="card dashcard mb-3">
            
                <div class="card-body">

                    <div class="form-row">
                        <div class="col col-12 col-md-6">
                            <az-input icon="fas fa-search" v-model="search">
                                <template v-slot:buttonposb>
                                    <importacao service="estoque_items" @refresh="load()" />
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'A'">
                                    Ativos
                                </button>
                                <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'T'">
                                    Todos
                                </button>
                            </div>
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <button type="button" class="btn btn-outline-success" @click="incluir ()">
                                Incluir Kit
                            </button>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum kit identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Kit'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }} 
                        </a>
                        <a href="#" @click.prevent="search == '&quot;' + dado.grupo.search + '&quot;' ? search = '' : search = '&quot;' + dado.grupo.search + '&quot;'" class="card-link">
                            <small class="text-muted" v-if="dado.grupo">
                                {{ dado.grupo.search }}
                            </small>
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary">
                                {{ dado.componentes.length }}
                            </span>
                            <span v-if="dado.js_classes">
                                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in dado.js_classes" :key="itx">
                                    <span class="badge badge-success ml-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </span>
                            <button type="button" class="btn btn-outline-primary btn-sm ml-2" @click="emitir_etiqueta(dado)">
                                <i class="fa fa-tags" aria-hidden="true"></i>
                            </button>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_estoque_item ? '' : 'Novo' }}
                            Kit 
                            <span class="badge badge-secondary ml-1" v-if="item && item.id_estoque_item">
                                #{{ item.id_estoque_item }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_estoque_item" />
                            </div>
                        </div>
                        
                        <div class="row" v-if="false">
                            <div class="col col-12">
                                <small class="text-muted">Classificação</small>
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observação"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="item.st_observacao" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="select"
                                    label="Grupo"
                                    service="estoque_grupos.index"
                                    optionsMode="aql"
                                    optionsDisplay="search"
                                    optionsData="id_estoque_grupo"
                                    :validate="validate"
                                    v-model="item.id_estoque_grupo" />
                            </div>  
                        </div>

                        <div class="row mt-3 mb-1">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Kit de Ressuprimento"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_kit_ressup" />

                                <div v-if="item.fl_kit_ressup" class="alert alert-info small">
                                    Abate o saldo do local de armazenagem no ato da solicitação.
                                </div>
                            </div>
                        </div>

                        <az-sub-title title="Componentes" />
                        <div class="form-row" v-for="(comp, icx) in lista_componentes" :key="icx">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    :label="icx ? '' : 'Descrição'"
                                    sizing="sm"
                                    icon="fa fa-minus fa-fw"
                                    :buttonIcon="true"
                                    buttonColor="outline-danger"
                                    buttonText="fa fa-minus fa-fw"
                                    @clickButton="comp.excluido = true"
                                    :edicao="false"
                                    v-model="comp.item.search">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">#{{ comp.id_estoque_item }}</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    :label="icx ? '' : 'Quantidade'"
                                    sizing="sm"
                                    type="number"
                                    required
                                    :validate="validate"
                                    v-model="comp.in_quantidade">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">{{ comp.item.st_unidade_estoque }}</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-2" v-if="false">
                                <az-input
                                    :label="icx ? '' : 'Para Cada'"
                                    sizing="sm"
                                    type="number"
                                    required
                                    :validate="validate"
                                    v-model="comp.in_para_cada" />
                            </div>
                        </div>

                        <selecao-material :blocklote="true" @selecionado="incluir_componente" />
                        
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="estoqueItem" :id="item.id_estoque_item" v-if="item && item.id_estoque_item" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_estoque_item ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <estoque-etiqueta ref="estoque_etiqueta" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import Multiselect from 'vue-multiselect';
import Importacao from '../../cadastros/shared/Importacao.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import SelecaoMaterial from './SelecaoMaterial.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import EstoqueEtiqueta from './EstoqueEtiqueta.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            metadados: null, 
            anos: [],
            unidade: "", 
            options_classes: [],
            novaCobranca: "", 
        }
    },

    props: ['cadastro'],

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        Multiselect,
        Importacao,
        AzAuditLogButton,
        SelecaoMaterial,
        AzSubTitle,
        EstoqueEtiqueta
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_componentes: function () { 
            if ( !this.item )
                return [];

            return this.item.componentes.filter(item => !item.excluido);
        },  
    },

    methods: { 
        emitir_etiqueta(item) {
            const etiquetaItens = [
                 {
                    checked: true,
                    id_estoque_item: item.id_estoque_item,
                    lote: null,
                    validade: null,
                    qtde: 1,
                    search: item.search,
                }
            ];

            this.$refs.estoque_etiqueta.show(etiquetaItens);
        },

        incluir_componente (material) {
            this.item.componentes.push({ 
                item: material, 
                id_estoque_item_pai: this.item.id_estoque_item, 
                id_estoque_item: material.id_estoque_item, 
                in_quantidade: 1,
                in_para_cada: 1, 
                excluido: false, 
            });
        },

        removerCobranca () { 
            this.item.cobranca = null;
            this.item.id_material = null;
            this.item.id_medicamento = null;
        },

        definirCobranca () { 
            if ( !this.novaCobranca ) 
                return;

            this.item.cobranca = _.cloneDeep(this.novaCobranca);
            this.item.id_material = this.novaCobranca.id_material;
            this.item.id_medicamento = this.novaCobranca.id_medicamento;

            this.novaCobranca = "";

            this.$nextTick(() => { 
                this.novaCobranca = null;
            });
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_estoque_item: null, 
                st_estoque_item: "",
                st_unidade_estoque: "Unidade",
                st_unidade_compra: "Unidade",
                in_fator_conversao: 1,
                st_observacao: "",  
                fl_ativo: true,
                fl_kit: true, 
                js_classes: [], 
                fl_controla_lote: false, 
                componentes: [], 
                fl_kit_ressup: false, 
            };

            this.editar (item);
        },

        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: 'estoque_items.index',
                    id: 'lista',
                    parms: { 
                        cadastro: true, 
                        kit: true, 
                    }
                },
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },

        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);
            $('#edicaoModal').modal('show');
        },

        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'estoque_items', 
                dados: this.item,
                modal: 'edicaoModal',
                toast: true,
                reload: true, 
            });

        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'estoque_items.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 

        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Kit", path: "/suprimentos/kit" }
        ]);

        this.$util.loadItem(this, { 
            service: 'estoque_items',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        this.load ();
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>